<template>
    <div class="dashboard">
        <div class="page-container">
            <div class="header">
                <div class="header-left">
                    <h2 class="title">集运数据</h2>
                    <div class="total-count">总条数：{{ total }}</div>
                </div>
                <div class="header-right">
                    <div class="filter-section">
                        <div class="filter-label">登录时间</div>
                        <el-date-picker @change="getStats" v-model="datePickerVal" value-format="YYYY-MM-DD" format="YYYY-MM-DD"
                            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>

                        <div class="filter-label">详细分类</div>
                        <el-select v-model="filter1" placeholder="请选择" class="filter-select"
                            :disabled="filter2 !== '全部'" @change="handleFilter1Change">
                            <el-option label="全部" value="全部"></el-option>
                            <el-option v-for="item in filter1Options" :key="item" :label="item"
                                :value="item"></el-option>
                        </el-select>
                        <div class="filter-label">结算分类</div>
                        <el-select v-model="filter2" placeholder="请选择" class="filter-select"
                            :disabled="filter1 !== '全部'" @change="handleFilter2Change">
                            <el-option label="全部" value="全部"></el-option>
                            <el-option v-for="item in filter2Options" :key="item" :label="item"
                                :value="item"></el-option>
                        </el-select>
                        <el-button type="primary" @click="clickExport">导出</el-button>
                    </div>
                    <h2 @click="handleLogout" class="title">{{ adminInfo.realName }}:{{ adminInfo.username }}</h2>
                </div>
            </div>

            <el-config-provider :locale="zhCn">
                <el-table :data="statsList" border stripe class="stats-table" :header-cell-style="{
                    backgroundColor: '#7eb8e7',
                    color: '#fff',
                    fontWeight: '600',
                }" :row-class-name="getRowClassName" @row-click="handleRowClick" highlight-current-row>
                    <el-table-column prop="targetUserName" label="用户类型" align="center" width="120"
                        show-overflow-tooltip />
                    <el-table-column prop="osVal" label="系统类型" align="center" width="85" show-overflow-tooltip />

                    <el-table-column prop="provinceCode" label="省份编码" align="center" width="85" show-overflow-tooltip />
                    <el-table-column prop="advertiserid" label="广告主ID" align="center" width="90"
                        show-overflow-tooltip />
                    <el-table-column prop="aid" label="广告计划ID" align="center" width="110" show-overflow-tooltip />
                    <el-table-column prop="cid" label="广告创意ID" align="center" width="120" show-overflow-tooltip />
                    <el-table-column prop="campaignid" label="广告组ID" align="center" width="120" show-overflow-tooltip />

                    <el-table-column prop="isCallbackVal" label="是否回传" align="center" width="85"
                        show-overflow-tooltip />
                    <el-table-column prop="callbackTime" label="回传时间" align="center" width="160"
                        show-overflow-tooltip />
                    <el-table-column prop="monitorTime" label="监测时间" align="center" width="160" show-overflow-tooltip />
                    <el-table-column prop="reportTime" label="上报时间" align="center" width="160" show-overflow-tooltip />
                    <el-table-column prop="loginTime" label="登录时间" align="center" width="160" show-overflow-tooltip />
                    <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip />
                </el-table>
                <el-pagination class="pagination" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-config-provider>
        </div>
    </div>
</template>

<script>
import axios from "@/axios/create";
import { ElButton, ElInput, ElMessage, ElMessageBox, ElOption, ElPagination, ElSelect, ElTable, ElTableColumn } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { defineComponent } from "vue";
import { mapMutations } from "vuex";

export default defineComponent({
    name: "dashboard",
    components: {
        ElTable,
        ElTableColumn,
        ElButton,
        ElInput,
        ElPagination,
        ElSelect,
        ElOption,
    },
    data() {
        return {
            zhCn,
            currentPage: 1,
            pageSize: 16,
            total: 0,
            filter1: "全部",
            filter2: "全部",
            datePickerVal: [],
            filter1Options: [],
            filter2Options: [],
            filter1Data: {},
            filter2Data: {},
            statsList: [],
            adminInfo: {},
        };
    },
    computed: {},
    mounted() {
        this.getFilter1Options();
        this.getFilter2Options();
        this.getStats();
        this.getAdminInfo();
    },
    created() { },
    watch: {},
    methods: {
        ...mapMutations(["setSaToken"]),
        getAdminInfo() {
            axios.get("/admin/info").then((res) => {
                if (res.code === 200) {
                    this.adminInfo = res.data;
                }
            });
        },
        clickExport() {
            let params = {
                targetUsers: "",
                 loginTimeStart: (this.datePickerVal && this.datePickerVal[0]) || "",
                loginTimeEnd: (this.datePickerVal && this.datePickerVal[1]) || "",
            };
            if (this.filter1 !== "全部") {
                params.targetUsers = this.filter1Data[this.filter1] || "";
            } else if (this.filter2 !== "全部") {
                params.targetUsers = this.filter2Data[this.filter2] || "";
            }
            //    // 创建a标签模拟点击跳转 
            const link = document.createElement('a');
            link.href = window.location.origin + "/api/baiheKs/export?pageNum=1&pageSize=" + this.total + "&targetUsers=" + params.targetUsers + "&loginTimeStart=" + params.loginTimeStart + "&loginTimeEnd=" + params.loginTimeEnd;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleLogout() {
            ElMessageBox.confirm("确认退出登录吗?", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "success",
            }).then(() => {
                this.logoutRequest();
            }).catch(() => { });
        },
        logoutRequest() {
            axios.post("/admin/logout").then((res) => {
                if (res.code === 200) {
                    ElMessage.success("退出成功");
                    this.setSaToken("");
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                } else {
                    ElMessage.error(res.message || "退出失败");
                }
            });
        },
        getFilter1Options() {
            axios.get("/baiheTargetUserMap/getTargetUserNamesWithValues").then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.filter1Data = data;
                    this.filter1Options = Object.keys(data).map((key) => key);
                }
            }).catch(() => {
                this.filter1Options = [];
                this.filter1Data = {};
            });
        },
        getFilter2Options() {
            axios.get("/baiheTargetUserMap/getTypesWithValues").then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.filter2Data = data;
                    this.filter2Options = Object.keys(data).map((key) => key);
                }
            }).catch(() => {
                this.filter2Options = [];
                this.filter2Data = {};
            });
        },
        handleFilter1Change(value) {
            if (value !== "全部") {
                this.filter2 = "全部";
            }
            this.currentPage = 1;
            this.getStats();
        },
        handleFilter2Change(value) {
            if (value !== "全部") {
                this.filter1 = "全部";
            }
            this.currentPage = 1;
            this.getStats();
        },
        getStats() {
            this.statsList = [];
            const params = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                loginTimeStart: (this.datePickerVal && this.datePickerVal[0]) || "",
                loginTimeEnd: (this.datePickerVal && this.datePickerVal[1]) || "",
            };

            if (this.filter1 !== "全部") {
                params.targetUsers = this.filter1Data[this.filter1] || "";
            } else if (this.filter2 !== "全部") {
                params.targetUsers = this.filter2Data[this.filter2] || "";
            }

            axios.get("/baiheKs/page", params).then((res) => {
                if (res.code === 200) {
                    const records = res.data.records || [];
                    this.total = res.data.total || 0;
                    this.statsList = records.map((item) => {
                        if (item.isCallback == 0) {
                            item.isCallbackVal = "未回传";
                        } else if (item.isCallback == 1) {
                            item.isCallbackVal = "已回传";
                        }
                        if (item.os == 0) {
                            item.osVal = "安卓";
                        } else if (item.os == 1) {
                            item.osVal = "iOS";
                        } else {
                            item.osVal = "鸿蒙";
                        }

                        item.createTime = this.formatTime(item.createTime);
                        item.loginTime = this.formatTime(item.loginTime);
                        item.reportTime = this.formatTime(item.reportTime);
                        item.monitorTime = this.formatTime(item.monitorTime);
                        item.callbackTime = this.formatTime(item.callbackTime);
                        return item;
                    });
                }
            }).catch(() => {
                this.statsList = [];
                this.total = 0;
            });
        },
        getRowClassName({ rowIndex }) {
            return rowIndex % 2 === 0 ? "even-row" : "odd-row";
        },
        handleRowClick(row) {
            const { href } = this.$router.resolve({
                path: '/detail',
                query: { id: row.id }
            });
            console.log(row);
            window.open(href, '_blank');
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getStats();
        },
        formatTime(time, format = "yyyy-MM-dd HH:mm:ss") {
            const date = time instanceof Date ? time : new Date(time);
            if (isNaN(date.getTime())) return "";

            const o = {
                "M+": date.getMonth() + 1,
                "d+": date.getDate(),
                "H+": date.getHours(),
                "m+": date.getMinutes(),
                "s+": date.getSeconds(),
                "S+": date.getMilliseconds()
            };

            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }

            for (let k in o) {
                if (new RegExp(`(${k})`).test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
                }
            }
            return format;
        }
    },
});
</script>

<style lang="scss" scoped>
.dashboard {
    min-height: 100vh;
    max-height: 100vh;
    background-color: #f5f7fa;
    padding: 20px;

    .page-container {
        min-height: calc(100vh - 40px);
        max-height: calc(100vh - 40px);
        margin: 0;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        padding: 24px;
        overflow: hidden;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .title {
                font-size: 20px;
                font-weight: 600;
                color: #1f2937;
                margin: 0;
                white-space: nowrap;

                &:hover {
                    color: #409eff;
                }
            }

            .total-count {
                font-size: 16px;
                font-weight: 500;
                color: #1f2937;
            }

            .header-left {
                display: flex;
                align-items: center;
                gap: 20px;
            }

            .header-right {
                display: flex;
                align-items: center;
                gap: 20px;

                .filter-section {
                    display: flex;
                    gap: 12px;

                    .filter-label {
                        font-size: 16px;
                        font-weight: 500;
                        color: #1f2937;
                        display: flex;
                        align-items: center;
                    }

                    .filter-select {
                        width: 150px;
                    }
                }
            }
        }

        .stats-table {
            --el-table-header-text-color: #fff;
            --el-table-row-hover-bg-color: #e8f4ff;
            border-radius: 8px;
            overflow: hidden;
            height: calc(100vh - 200px);

            :deep(.el-table__header-wrapper) {
                th.el-table__cell {
                    white-space: nowrap;
                }
            }

            :deep(.el-table__body-wrapper) {
                td.el-table__cell {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .even-row {
                background-color: #f9fafc;
            }

            .odd-row {
                background-color: #fff;
            }
        }

        .pagination {
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
    }
}

.el-button--text {
    color: #1989fa;

    &:hover {
        color: #0f6cbd;
    }
}
</style>
